import { Component } from 'react';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const AllClinicalNotes = withLazyFallback(
  () => import('components/practice/charts/ClinicalNote/AllClinicalNotes/AllClinicalNote')
);
const ClinicalNote = withLazyFallback(
  () => import('components/practice/charts/ClinicalNote/ClinicalNote')
);
const CurrentNote = withLazyFallback(
  () => import('components/practice/charts/ClinicalNote/CurrentNote/CurrentNote')
);
const MyScribeAI = withLazyFallback(
  () => import('components/practice/charts/ClinicalNote/MyScribeAI/MyScribeAI')
);
const AmbientListening = withLazyFallback(
  () =>
    import('components/practice/charts/ClinicalNote/MyScribeAI/Templates/AmbientListening/AmbientListening')
);
const MyOwnTemplate = withLazyFallback(
  () =>
    import('components/practice/charts/ClinicalNote/MyScribeAI/Templates/MyOwnTemplate/MyOwnTemplate')
);
const MyScribeTemplate = withLazyFallback(
  () =>
    import('components/practice/charts/ClinicalNote/MyScribeAI/Templates/MyScribeTemplate/MyScribeTemplate')
);

const PRACTICE_CHARTS_CLINICAL_NOTES = [
  {
    path: 'clinical-notes',
    element: <AllClinicalNotes />,
    handle: { title: 'Clinical Notes' },
    children: [
      {
        path: ':appointmentId',
        element: <ClinicalNote />,
        handle: { title: 'Clinical Note' },
        children: [
          {
            element: <CurrentNote />,
            children: [
              {
                path: ':type',
                element: <Component />,
                children: [
                  {
                    path: ':formName',
                    element: <Component />
                  }
                ]
              }
            ]
          },
          {
            path: 'myscribe-ai',
            element: <MyScribeAI />,
            handle: { title: 'MyScribe AI' },
            children: [
              { path: 'map-my-own-template', element: <MyOwnTemplate /> },
              { path: 'automap', element: <MyScribeTemplate /> },
              { path: 'ambient-listening', element: <AmbientListening /> },
              { path: '*', element: <NotFound /> }
            ]
          }
        ]
      }
    ]
  }
];

export default PRACTICE_CHARTS_CLINICAL_NOTES;
